<form [formGroup]="inputForm" fxLayoutGap="10px" fxLayoutAlign="start center">
  <mat-form-field class="input-field" color="accent">
    <input formControlName="text" matInput [placeholder]="'FILTER_ENGINE.PLACEHOLDER' | translate" />
  </mat-form-field>

  <button
    mat-mini-fab
    class="add-button-off"
    color="accent"
    type="submit"
    [disabled]="!text.value"
    [ngClass]="{ 'add-button-on': text.value }"
    (click)="onInputValidation()"
  >
    <mat-icon>add</mat-icon>
  </button>
</form>
